<template>
  <div id="hres4ax-popup2-tab3" class="panel box-collapse border-color-skin">
    <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion2" href="#popup2tab3">
      <h3 class="box-title">
        <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['STDPOSP3']['10'] }}
      </h3>
    </div>
    <div id="popup2tab3" class="panel-collapse collapse tab-detail">
      <div class="panel-body">
        <div class="detail detail-responsive panel-detail-filter">
          <hrms-table :columns="popup2Tab3Table" 
                      :data="data"
                      :searchDisp="false"  />
        </div>
      </div>
      <div class="modal-footer" >
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'hres4ax-popup2-tab3',
  props: [ 'labels', 'data', 'popup2Tab3Table' ]
}
</script>


// WEBPACK FOOTER //
// popup2Tab3.vue?4a9c58a8